// extracted by mini-css-extract-plugin
export default {"Container":"intro_Container__zSRDe","Image":"intro_Image__zFBNM"};